import {Box, TableCell, TableRow, Typography} from "@mui/material";
import {formatTime} from "../../../../utils/timeUtils";
import {ActiveGame, ActiveTrend} from "../../../../types/nbaTypes";
import {useTheme} from "@mui/material/styles";
import {BetboardRow} from "../../../../types/types";
import {GameInfoToolTip} from "../../../molecules/GameInfoToolTip/GameInfoToolTip";
import {BetboardTableLabel} from "./BetboardTableLabel";
import {getImageUrl} from "../../../../utils/helperFunctions";

interface BetboardTableRowProps {
    sport: string;
    row: BetboardRow;
    handleRowClick: (team: string, oTeam: string, date: string) => void,
}

export const BetboardTableRow = (
        {row, handleRowClick, sport = 'ncaabb'}: BetboardTableRowProps
    ) => {
    const theme = useTheme()
    let teamActiveTrends: ActiveTrend[] = [];
    let oTeamActiveTrends: ActiveTrend[] = [];
    let overActiveTrends: ActiveTrend[] = [];
    let underActiveTrends: ActiveTrend[] = [];
    const isCollegeSport = sport === 'ncaabb' || sport === 'ncaafb';

    row?.activeTrends?.forEach((trend: ActiveTrend) => {
        if (trend.activeGames?.some((game: ActiveGame) => game.activeTeam === row.team && trend.isAtsTrend)) {
            teamActiveTrends.push(trend);
        }

        if (trend.activeGames?.some((game: ActiveGame) => game.activeTeam === row.oTeam && trend.isAtsTrend)) {
            oTeamActiveTrends.push(trend);
        }

        if (trend.isOuTrend && (trend.overs || 0) / (trend.unders || 0) > 1) {
            overActiveTrends.push(trend);
        }

        if (trend.isOuTrend && (trend.overs || 0) / (trend.unders || 0) < 1) {
            underActiveTrends.push(trend);
        }
    });
    let formattedTeamName = '';
    let formattedOTeamName = '';
    let formattedTeamLine = '';
    let formattedOTeamLine = '';
    if(typeof row.line === 'number' && row.line > 0) formattedTeamLine = ` +${row.line}`
    if(typeof row.line === 'number' && row.line <= 0) formattedTeamLine = ` ${row.line}`
    if(typeof row.oLine === 'number' && row.oLine > 0) formattedOTeamLine = ` +${row.oLine}`
    if(typeof row.oLine === 'number' && row.oLine <= 0) formattedOTeamLine = ` ${row.oLine}`

    formattedTeamName = `${row.school || row.team}${formattedTeamLine}`
    formattedOTeamName += `${row.oSchool || row.oTeam}${formattedOTeamLine}`

    if(row?.school?.includes('Iowa State') && !row.line) {
        console.log("row: ", row)
        return null;
    }
    return (
        <TableRow
            onClick={() => handleRowClick(row.team, row.oTeam, row.date.toString())}
            sx={{
                '& > *': {paddingTop: '9px !important', paddingBottom: '9px !important'},
                '&:hover': {
                    backgroundColor: 'lightgrey',
                    cursor: 'pointer',
                },
            }}
        >
            <TableCell component="th" scope="row" align="left">
                {formatTime(row.startTime, false)}
                <GameInfoToolTip game={row} />
            </TableCell>
            <TableCell component="th" scope="row" align="left">
                <Box display="flex" alignContent="center">
                    {getImageUrl(row.school || row.team, sport)}
                    {formattedTeamName ?
                        <BetboardTableLabel
                            label={formattedTeamName}
                            color={theme.palette.grey[800]}
                            fontWeight={"inherit"}
                            variant={'body2'}
                        /> :
                        ''
                    }
                    {row.rest === 0 ?
                        <BetboardTableLabel
                            label={'No Rest'}
                            color={theme.palette.warning.light}
                        /> :
                        ''
                    }
                    {teamActiveTrends?.length > 0 ?
                        <BetboardTableLabel
                            label={teamActiveTrends?.length.toString() || ''}
                            color={theme.palette.info.light}
                        /> :
                        ''
                    }
                    {Math.abs(row?.streak) > 2 ?
                        <BetboardTableLabel
                            label={`${row?.streak}${row?.streak > 2 ? 'W' : 'L'}`}
                            color={row.streak > 0 ? theme.palette.success.light : theme.palette.warning.light}
                        /> :
                        ''
                    }
                    {Math.abs(row?.atsStreak) > 2 ?
                        <BetboardTableLabel
                            label={`${row?.atsStreak}ATS`}
                            color={row.atsStreak > 0 ? theme.palette.success.light : theme.palette.warning.light}
                        /> :
                        ''
                    }
                    {Math.abs(row?.ouStreak) > 2 ?
                        <BetboardTableLabel
                            label={`${row?.ouStreak}${row.ouStreak > 0 ? 'OV' : 'UN'}`}
                            color={row.ouStreak > 0 ? theme.palette.success.light : theme.palette.warning.light}
                        /> :
                        ''
                    }
                </Box>
            </TableCell>
            <TableCell align="left">
                <Box
                    display="flex"
                    alignContent="center"
                >
                    {getImageUrl(row.oSchool || row.oTeam, sport)}
                    {formattedOTeamName ?
                        <BetboardTableLabel
                            label={formattedOTeamName}
                            color={theme.palette.grey[800]}
                            fontWeight={"inherit"}
                            variant={"body2"}
                        /> :
                        ''
                    }
                    {row.oRest === 0 ?
                        <BetboardTableLabel
                            label={'No Rest'}
                            color={theme.palette.warning.light}
                        /> :
                        ''
                    }
                    {oTeamActiveTrends?.length > 0 ?
                        <BetboardTableLabel
                            label={oTeamActiveTrends?.length.toString() || ''}
                            color={theme.palette.info.light}
                        /> :
                        ''
                    }
                    {Math.abs(row?.oStreak) > 2 ?
                        <BetboardTableLabel
                            label={`${row?.oStreak}${row?.oStreak > 2 ? 'W' : 'L'}`}
                            color={row.oStreak > 0 ? theme.palette.success.light : theme.palette.warning.light}
                        /> :
                        ''
                    }
                    {Math.abs(row?.oAtsStreak) > 2 ?
                        <BetboardTableLabel
                            label={`${row?.oAtsStreak}ATS`}
                            color={row.oAtsStreak > 0 ? theme.palette.success.light : theme.palette.warning.light}
                        /> :
                        ''
                    }
                    {Math.abs(row?.oOuStreak) > 2 ?
                        <BetboardTableLabel
                            label={`${row?.oOuStreak}${row.oOuStreak > 0 ? 'OV' : 'UN'}`}
                            color={row.oOuStreak > 0 ? theme.palette.success.light : theme.palette.warning.light}
                        /> :
                        ''
                    }
                </Box>
            </TableCell>
            <TableCell align="left">
                {row.total}
                <Typography
                    component="span"
                    variant="caption"
                    color={theme.palette.info.light}
                    style={{fontWeight: '600'}}
                >
                    {overActiveTrends?.length ? (`   ${overActiveTrends?.length}OV`) : ''}
                </Typography>
                <Typography
                    component="span"
                    variant="caption"
                    color={theme.palette.info.light}
                    style={{fontWeight: '600'}}
                >
                    {underActiveTrends?.length ? (`   ${underActiveTrends?.length}UN`) : ''}
                </Typography>
            </TableCell>
        </TableRow>
    )
}